export default {
  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderBottom: '2px solid #2d313b',
    paddingBottom: '10px',
    marginBottom: '10px'
  },
  copyButton: {
    marginLeft: 'auto'
  }
};